module.exports = __webpack_public_path__ + "img/QQ.c080d6cd.png";